import React, { FC } from 'react'

import { cn } from '../../utils/cn'

import LoadMoreIcon from '../../../img/icons/+.svg'

export interface ResourcesLoadMoreProps {
  className?: string
  loading: boolean
  actions: {
    fetchNextSlice: () => Promise<void>
  }
  hasNextPage: boolean
}

const ResourcesLoadMore: FC<ResourcesLoadMoreProps> = ({
  className,
  loading,
  actions: { fetchNextSlice },
  hasNextPage,
}) => {
  return (
    <div
      className={cn(
        'pt-4 pb-10 w-full mx-auto text-center text-base font-gotham border-l border-rule-grey xl:bg-[#F5F7F8]',
        className,
      )}
    >
      {loading ? (
        <div className="py-[15px] px-0">Loading resources...</div>
      ) : (
        hasNextPage && (
          <button
            className="flex flex-row w-full py-3 justify-center"
            onClick={() => fetchNextSlice()}
          >
            <img className="mr-3" src={LoadMoreIcon} alt="Load more icon" /> Load more
          </button>
        )
      )}
    </div>
  )
}

export default ResourcesLoadMore
